import { ReportsComponent } from "@/features/esoPerson/reports"

export const ReportsPage = () => {
  return <ReportsComponent />
}
